import { default as desktop } from "./desktop.module.scss";
import { default as laptop } from "./laptop.module.scss";
import { default as tablet } from "./tablet.module.scss";

const breakpoints = { ...desktop, ...laptop, ...tablet }; // Order matters

export default breakpoints;
